/*
import { dataSet } from '@/dataSet/index';
 * @Author: your name
 * @Date: 2021-05-05 10:22:12
 * @LastEditTime: 2021-09-10 11:08:12
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \dc-wsy-pet-raise-plan-front\store\store.js
 */
// import * as localStorage from './localStorage'
let Vue
const dataSet = {
    globalData: {
        loading: false,
        // lang: 'zhCHT'
        lang: window.navigator.language.slice(0, 2) === 'en' ? 'zhEn' : 'zhCHT'
    }
}
class Store {
    constructor () {
        this.vm = new Vue({
         data: {
           ...dataSet
         }
        })
    }

    get globalData () {
        return this.vm.globalData
    }

      /**
   * @name: 设置已经存在的key的值 整个对象
   * @param {*} target 要设值的对象
   * @param {*} data 数据对象
   * @return {*}
   */
  setData (targetKey, data) {
    for (const key in data) {
      if (Object.hasOwnProperty.call(data, key)) {
        this.vm[targetKey][key] = data[key]
      }
    }
  }

  /**
   * @name: 修改对象中的某个key
   * @param {*} targetKey
   * @param {*} data
   * @return {*}
   */
  changeData (targetKey, data) {
    const keyArr = targetKey.split('.')
    const lastObject = keyArr.reduce((t, v) => {
      return t[v]
    }, this.vm)
    for (const key in data) {
      if (Object.hasOwnProperty.call(data, key)) {
        Vue.set(lastObject, key, data[key])
      }
    }
  }
}

const install = (_Vue) => {
    Vue = _Vue
    Vue.mixin({
        beforeCreate () {
          if (this.$options.store) {
              this.store = this.$options.store
          } else {
              this.store = this.$parent && this.$parent.store
          }
        }
    })
}
export default { Store, install }
